import { render, staticRenderFns } from "./ReseveVerificationPopupView.vue?vue&type=template&id=45a99df5&scoped=true&"
import script from "./ReseveVerificationPopupView.vue?vue&type=script&lang=js&"
export * from "./ReseveVerificationPopupView.vue?vue&type=script&lang=js&"
import style0 from "./ReseveVerificationPopupView.vue?vue&type=style&index=0&id=45a99df5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a99df5",
  null
  
)

export default component.exports